module.exports = __webpack_public_path__ + "static/media/ex-login.730b7e67.jpg";